import styled from 'styled-components';

interface IColorSymbol {
  color: string;
}

export const ChartWrapper = styled.div`
  margin-top: 20px;
`;

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
`;

export const TooltipHeader = styled.div`
  font-weight: bold;
  margin-bottom: 3px;
`;

export const TooltipItem = styled.div`
  display: flex;
  padding: 2px 0;
  align-items: center;
`;

export const ColorSymbol = styled.div<IColorSymbol>`
  margin-right: 4px;
  min-width: 10px;
  max-width: 10px;
  min-height: 10px;
  max-height: 10px;
  background-color: ${({ color }) => color};
`;
